import React from 'react';
import { theme } from '../../design/theme';

interface SectionCardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export const SectionCard: React.FC<SectionCardProps> = ({ title, subtitle, children, actions }) => {
  return (
    <div style={{
      ...theme.card,
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing.lg
    }}>
      {(title || actions) && (
        <div style={{
          padding: `${theme.spacing.md} ${theme.spacing.lg}`,
          borderBottom: `1px solid ${theme.colors.neutral[200]}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: theme.colors.neutral[50],
          borderTopLeftRadius: theme.card.borderRadius,
          borderTopRightRadius: theme.card.borderRadius,
        }}>
          <div>
            {title && <h3 style={{ ...theme.typography.h3, margin: 0 }}>{title}</h3>}
            {subtitle && <p style={{ ...theme.typography.caption, margin: `${theme.spacing.xs} 0 0 0` }}>{subtitle}</p>}
          </div>
          {actions && <div>{actions}</div>}
        </div>
      )}
      <div style={{ padding: theme.spacing.lg }}>
        {children}
      </div>
    </div>
  );
};

export const LoadingState: React.FC = () => (
  <div style={{ padding: theme.spacing.xl, textAlign: 'center' }}>
    <div style={{ ...theme.typography.body, color: theme.colors.neutral[500] }}>Loading...</div>
  </div>
);

export const ErrorState: React.FC<{ message?: string }> = ({ message = 'Something went wrong' }) => (
  <div style={{ 
    padding: theme.spacing.xl, 
    textAlign: 'center',
    backgroundColor: theme.colors.critical.light,
    borderRadius: theme.card.borderRadius,
    border: `1px solid ${theme.colors.critical.main}`
  }}>
    <div style={{ ...theme.typography.bodyBold, color: theme.colors.critical.dark }}>{message}</div>
  </div>
);

export const EmptyState: React.FC<{ message?: string }> = ({ message = 'No data available' }) => (
  <div style={{ 
    padding: theme.spacing.xl, 
    textAlign: 'center',
    backgroundColor: theme.colors.neutral[50],
    borderRadius: theme.card.borderRadius,
    border: `1px dashed ${theme.colors.neutral[300]}`
  }}>
    <div style={{ ...theme.typography.body, color: theme.colors.neutral[500] }}>{message}</div>
  </div>
);
